module.exports = __webpack_public_path__ + "static/media/Portrait-10077.3826d6fb.jpg";